{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Välj en artikel",
  "tableResizer": "Storleksändrare"
}
